import { useTellescopeMutation } from "@tellescope/tanstack-query";
import { EditablePersonCell } from "./EditablePersonCell";
import { useCallback } from "react";

export interface UserCellProps {
  userId?: string;
  ticketId: string;
  avatarOnly?: boolean;
}

export const UserCell = ({ userId, ticketId, avatarOnly }: UserCellProps) => {
  const updateTicketMutation = useTellescopeMutation({
    model: "tickets",
    method: "updateOne",
  });

  const onChange = useCallback(
    (userId: string | null) => {
      updateTicketMutation.mutateAsync({
        id: ticketId,
        owner: userId ?? "",
      });
    },
    [ticketId, updateTicketMutation]
  );

  return <EditablePersonCell mode="user" value={userId} onChange={onChange} avatarOnly={avatarOnly} />;
};
